import React, { Fragment } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Hero from '../components/Hero/Hero';
import Options from '../components/Options/Options';
import CTA from '../components/CTA/CTA';
import '../components/Benefits/Benefits.css';
import Footer from '../components/Footer/Footer';
import FindUS from '../components/FindUs/FindUs';
import Sell from '../components/Sell/Sell';
import SocialProof from '../components/SocialProof/SocialProof';
import Benefits from '../components/Benefits/Benefits';
import Content from '../components/Content/Content';
import Process from '../components/Process/Process';
import SEO from '../components/SEO/SEO';

type HomeProps = {}

const Home:React.FC<HomeProps> = (props: HomeProps) => {
  return (
    <Fragment>
      <SEO 
        title="Grupo GM | Renta de cajas secas y plataformas en Hidalgo"
        description="En Grupo GM nos especializamos en la renta de cajas secas y plataformas para el transporte de mercancías en Hidalgo. Ofrecemos soluciones logísticas flexibles y adaptadas a las necesidades de tu empresa."
        canonicalUrl="https://grupo-gm.mx/"
      />
      <Navbar />
      <Hero />
      <SocialProof />
      <Options />
      <Benefits
        title="¿Por qué elegirnos?"
        description="Aquí hay algunas razones por las cuales nuestros clientes prefieren rentar con nosotros en lugar de comprar."
        slots={[
          {
            title: 'Flexibilidad operativa',
            content: 'Rentar equipos proporciona flexibilidad en función de las necesidades cambiantes del negocio. Puedes ajustar el tamaño y la cantidad de equipos que necesitas según la demanda, sin comprometerte a largo plazo.'
          },
          {
            title: 'Mantenimiento incluido',
            content: 'Esto te dará tranquilidad ya que no tendrás que gestionar el mantenimiento y tendrás la garantía que los equipos estén en condiciones óptimas.'
          },
          {
            title: 'Costos iniciales más bajos',
            content: 'La compra de un equipo puede requerir una inversión inicial muy grande, por lo que rentarlo protegerá a otras áreas de tu negocio.'
          },
          {
            title: 'Evitar la depreciación',
            content: 'La propiedad de equipos conlleva la depreciación del valor con el tiempo. Al rentar equipos, te libras de este riesgo, ya que no eres el propietario.'
          },
          {
            title: 'Adaptabilidad a la demanda estacional',
            content: 'Si tu negocio experimenta cambios estacionales en la demanda, el alquiler de equipos te permite ajustar fácilmente la capacidad de tu flota según sea necesario.'
          },
          {
            title: 'Renovación de flota más fácil',
            content: 'Al rentar equipos, puedes tener acceso a unidades más nuevas y eficientes sin tener que preocuparte por vender o desechar equipos antiguos.'
          },
        ]}
      />
      <CTA
        title="Prueba nuestro servicio ya!" 
        description="Todo lo que necesitas para llevar a tu negocio al siguiente nivel."
        buttonText="Consultar disponibilidad"
      />
      <Content
        title='Renta de equipos en todo Hidalgo'
        description='Operamos en todo el estado de Hidalgo y zonas clave del centro del país, ofreciendo disponibilidad constante de equipos y atención rápida donde tu operación lo necesite.'
      />
      {/* <Gallery
        title="Equipos disponibles"
        description="Explora nuestra galería de equipos disponibles y conoce el estado, capacidades y características de cada equipo. Todas nuestras unidades se encuentran listas para trabajar y cumplir con tus necesidades de transporte y logística."
        buttonText="Verificar disponibilidad"
        images={[
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja14.jpeg",
            alt: "Cajas seca disponible 1"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja45.jpeg",
            alt: "Cajas seca disponible 2"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja31.jpeg",
            alt: "Cajas seca disponible 3"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/renta-plataformas/plataforma1.jpeg",
            alt: "Plataforma disponible 1"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja33.jpeg",
            alt: "Cajas seca disponible 4"
          },
          {
            src: "https://grupogm-assets.s3.us-east-1.amazonaws.com/equipos-disponibles/caja48.jpeg",
            alt: "Cajas seca disponible 5"
          }
        ]}
      /> */}
      <Process
        title="Proceso de renta de equipos"
        description="Nuestro proceso de renta de equipos es rápido, claro y sin complicaciones. Te acompañamos paso a paso, desde la confirmación de disponibilidad hasta la entrega del equipo en Hidalgo, garantizando un servicio eficiente y confiable para tu operación."
        steps={[
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"></path>
              </svg>
            ),
            title: 'Confirma disponibilidad de plataforma',
            description: 'Verificamos en tiempo real el equipo disponible según tus necesidades de capacidad y ubicación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 3v4a1 1 0 0 1-1 1H5m4 6 2 2 4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"></path>
              </svg>
            ),
            title: 'Envía tus datos y documentos',
            description: 'Compártenos la información necesaria para agilizar el proceso de renta y validación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 11.917 9.724 16.5 19 7.5"></path>
              </svg>
            ),
            title: 'Recibe y acepta tu cotización',
            description: 'Te enviamos una propuesta clara, sin costos ocultos, lista para aprobación.'
          },
          {
            icon: (
              <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"></path>
              </svg>
            ),
            title: 'Programa la entrega en Hidalgo',
            description: 'Coordinamos fecha y lugar para que recibas tu plataforma de forma puntual.'
          }
        ]}
      />
      <Sell />
      <FindUS />
      <Footer />
    </Fragment>
  )
}

export default Home;